<div class="home-page">

    <!-- =========================================================
         HERO
    ========================================================== -->
    <section class="hero-section">

        <div class="hero-background"></div>

        <div class="container-fluid page-container hero-container">

            <div class="hero-content">

                <div class="hero-copy">

                    <div class="hero-eyebrow">
                        DAHA İYİ BİR GELECEK İÇİN
                    </div>

                    <h1>
                        Teknolojiyle<br />
                        <span>daha fazlası mümkün.</span>
                    </h1>

                    <p>
                        Yazılım, yapay zekâ, bulut ve güvenlik çözümlerimizle
                        insanların, işletmelerin ve gezegenimizin geleceği için
                        anlamlı teknolojiler geliştiriyoruz.
                    </p>

                    <div class="hero-buttons">

                        <a href="#solutions" class="btn-anameta">
                            <span>Çözümlerimizi Keşfedin</span>

                            <svg viewBox="0 0 24 24">
                                <path d="M5 12H19"></path>
                                <path d="M14 7L19 12L14 17"></path>
                            </svg>
                        </a>

                        <a routerLink="/about" class="btn-outline-anameta">
                            Biz Kimiz?
                        </a>

                    </div>

                </div>


                <div class="hero-side-message">
                    <span>İNSAN</span>
                    <span>DOĞA</span>
                    <span>TEKNOLOJİ</span>
                    <span>GELECEK</span>
                    <i></i>
                </div>

            </div>


            <div class="hero-slider-box">

                <div class="slider-red-line"></div>

                <button type="button" class="slider-number active">
                    01
                </button>

                <button type="button" class="slider-number">
                    02
                </button>

                <button type="button" class="slider-number">
                    03
                </button>

            </div>

        </div>

    </section>


    <!-- =========================================================
         PRODUCT CATEGORIES
    ========================================================== -->
    <section id="products" class="category-section">

        <div class="container-fluid page-container">

            <div class="category-grid">

                <!-- APPLICATIONS -->
                <a routerLink="/applications" class="category-card">

                    <div class="category-icon">
                        <svg viewBox="0 0 48 48">
                            <rect x="5" y="5" width="14" height="14" rx="2"></rect>
                            <rect x="29" y="5" width="14" height="14" rx="2"></rect>
                            <rect x="5" y="29" width="14" height="14" rx="2"></rect>
                            <rect x="29" y="29" width="14" height="14" rx="2"></rect>
                        </svg>
                    </div>

                    <h3>Uygulamalar</h3>

                    <p>
                        İşinizi güçlendiren<br />
                        uygulamalar
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>


                <!-- SAAS -->
                <a routerLink="/saas" class="category-card">

                    <div class="category-icon">
                        <svg viewBox="0 0 48 48">
                            <path d="M13 36H36C41 36 44 32.5 44 28C44 23.8 40.8 20.4 36.7 20C35.5 13.8 30.5 9 24 9C18.8 9 14.2 12.1 12.2 16.7C6.7 17.1 3 21.1 3 26C3 31.5 7.3 36 13 36Z"></path>
                        </svg>
                    </div>

                    <h3>SaaS Hizmetleri</h3>

                    <p>
                        Hızlı, esnek, güvenilir
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>


                <!-- GAMES -->
                <a routerLink="/games" class="category-card">

                    <div class="category-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M15 17H33C38 17 41 21 42 27L44 35C45 39 41 42 38 39L32 34H16L10 39C7 42 3 39 4 35L6 27C7 21 10 17 15 17Z"></path>
                            <path d="M15 24V30"></path>
                            <path d="M12 27H18"></path>
                            <circle cx="32" cy="25" r="1.5"></circle>
                            <circle cx="36" cy="29" r="1.5"></circle>
                        </svg>

                    </div>

                    <h3>Oyunlar</h3>

                    <p>
                        Etkileyici deneyimler
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>


                <!-- API -->
                <a routerLink="/api-services" class="category-card">

                    <div class="category-icon code-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M16 10L4 24L16 38"></path>
                            <path d="M32 10L44 24L32 38"></path>
                            <path d="M28 6L20 42"></path>
                        </svg>

                    </div>

                    <h3>API Hizmetleri</h3>

                    <p>
                        Sistemlerinizi birbirine bağlayın
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>


                <!-- EDUCATION -->
                <a routerLink="/trainings" class="category-card">

                    <div class="category-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M4 18L24 7L44 18L24 29L4 18Z"></path>
                            <path d="M12 23V34L24 41L36 34V23"></path>
                        </svg>

                    </div>

                    <h3>Eğitimler</h3>

                    <p>
                        Bilgi, her yerde
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>


                <!-- DOCUMENTS -->
                <a routerLink="/documents" class="category-card">

                    <div class="category-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M11 5H30L39 14V43H11V5Z"></path>
                            <path d="M30 5V14H39"></path>
                            <path d="M18 23H32"></path>
                            <path d="M18 29H32"></path>
                            <path d="M18 35H28"></path>
                        </svg>

                    </div>

                    <h3>Dökümanlar</h3>

                    <p>
                        Tüm kaynaklara erişin
                    </p>

                    <span class="category-arrow">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>
                    </span>

                </a>

            </div>

        </div>

    </section>


    <!-- =========================================================
         STORY
    ========================================================== -->
    <section id="company" class="story-section">

        <div class="container-fluid page-container">

            <div class="row align-items-center g-0 story-row">

                <div class="col-lg-6">

                    <div class="story-image">

                        <div class="story-words">
                            <span>İNSAN</span>
                            <span>DOĞA</span>
                            <span>TEKNOLOJİ</span>
                            <span>GELECEK</span>

                            <i></i>
                        </div>


                        <div class="story-quote">

                            <p>
                                Doğa bize her zaman iki şey öğretti:<br />
                                denge ve devamlılık.
                            </p>


                            <div class="story-navigation">

                                <button type="button" aria-label="Önceki">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M15 6L9 12L15 18"></path>
                                    </svg>
                                </button>

                                <button type="button" aria-label="Sonraki">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M9 6L15 12L9 18"></path>
                                    </svg>
                                </button>

                            </div>

                        </div>

                    </div>

                </div>


                <div class="col-lg-6">

                    <div class="story-content">

                        <div class="section-label">
                            <i></i>
                            <span>ANAMETA</span>
                        </div>


                        <h2>
                            Teknoloji, daha iyi bir<br />
                            gelecek içindir.
                        </h2>


                        <p>
                            ANAMETA, insan, doğa, teknoloji ve gelecek arasında denge
                            kuran çözümler geliştirir. Yazılım, yapay zekâ, bulut,
                            siber güvenlik ve daha fazlasıyla, bugünün ihtiyaçlarını
                            yarının fırsatlarına dönüştürür.
                        </p>


                        <a routerLink="/about" class="btn-anameta story-button">

                            <span>Hikayemiz</span>

                            <svg viewBox="0 0 24 24">
                                <path d="M5 12H19"></path>
                                <path d="M14 7L19 12L14 17"></path>
                            </svg>

                        </a>

                    </div>

                </div>

            </div>

        </div>

    </section>


    <!-- =========================================================
         STATISTICS
    ========================================================== -->
    <section class="stats-section">

        <div class="container-fluid page-container">

            <div class="stats-panel">

                <div class="stat-item">

                    <strong>30+</strong>

                    <span>
                        Yıllık Deneyim
                    </span>

                </div>


                <div class="stat-item">

                    <strong>100+</strong>

                    <span>
                        Tamamlanan Proje
                    </span>

                </div>


                <div class="stat-item">

                    <strong>4</strong>

                    <span>
                        Ülke
                    </span>

                </div>


                <div class="stat-item">

                    <strong class="infinity">∞</strong>

                    <span>
                        Daha Fazlası İçin
                    </span>

                </div>

            </div>

        </div>

    </section>


    <!-- =========================================================
         SUSTAINABILITY
    ========================================================== -->
    <section id="solutions" class="sustainability-section">

        <div class="sustainability-background"></div>

        <div class="container-fluid page-container sustainability-container">

            <div class="sustainability-top">

                <div class="sustainability-title">

                    <div class="section-label">
                        <i></i>

                        <span>
                            SÜRDÜRÜLEBİLİR YARINLAR
                        </span>
                    </div>


                    <h2>
                        Teknolojiyle<br />
                        <span>dengede bir gelecek.</span>
                    </h2>

                </div>


                <div class="sustainability-text">

                    <p>
                        İnsan odaklı, doğaya saygılı ve sürdürülebilir
                        teknolojilerle daha iyi bir gelecek için çalışıyoruz.
                    </p>


                    <a routerLink="/sustainability">

                        <span>
                            Sürdürülebilirlik Yaklaşımımız
                        </span>

                        <svg viewBox="0 0 24 24">
                            <path d="M5 12H19"></path>
                            <path d="M14 7L19 12L14 17"></path>
                        </svg>

                    </a>

                </div>

            </div>


            <div class="sustainability-features">

                <!-- CLEAN -->
                <div class="sustainability-feature">

                    <div class="feature-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M40 8C24 9 12 15 9 31C19 33 31 28 36 17"></path>
                            <path d="M8 41C14 29 21 21 32 15"></path>
                        </svg>

                    </div>


                    <div>

                        <h3>
                            Daha Temiz Bir Yarın
                        </h3>

                        <p>
                            Kaynakları verimli kullanıyoruz.
                        </p>

                    </div>

                </div>


                <!-- COMMUNITY -->
                <div class="sustainability-feature">

                    <div class="feature-icon">

                        <svg viewBox="0 0 48 48">
                            <circle cx="24" cy="13" r="7"></circle>
                            <circle cx="10" cy="19" r="5"></circle>
                            <circle cx="38" cy="19" r="5"></circle>
                            <path d="M12 42V35C12 28 17 24 24 24C31 24 36 28 36 35V42"></path>
                            <path d="M2 39V33C2 28 5 25 10 25"></path>
                            <path d="M46 39V33C46 28 43 25 38 25"></path>
                        </svg>

                    </div>


                    <div>

                        <h3>
                            Daha Güçlü Toplumlar
                        </h3>

                        <p>
                            İnsanların potansiyelini destekliyoruz.
                        </p>

                    </div>

                </div>


                <!-- WORLD -->
                <div class="sustainability-feature">

                    <div class="feature-icon">

                        <svg viewBox="0 0 48 48">
                            <path d="M40 8C24 9 12 15 9 31C19 33 31 28 36 17"></path>
                            <path d="M8 41C14 29 21 21 32 15"></path>
                        </svg>

                    </div>


                    <div>

                        <h3>
                            Daha Yaşanabilir Bir Dünya
                        </h3>

                        <p>
                            Teknolojiyle kalıcı değer üretiyoruz.
                        </p>

                    </div>

                </div>

            </div>

        </div>

    </section>


    <!-- =========================================================
         CONTACT
    ========================================================== -->
    <section class="contact-section">

        <div class="container-fluid page-container">

            <div class="contact-panel">

                <div class="contact-content">

                    <div class="section-label">
                        <i></i>

                        <span>
                            BİRLİKTE DAHA FAZLASI MÜMKÜN
                        </span>
                    </div>


                    <h2>
                        Geleceği birlikte inşa edelim.
                    </h2>


                    <p>
                        Sizin için doğru çözümü bulalım. Ekibimizle iletişime geçin,<br class="d-none d-lg-block" />
                        fikirlerinizi gerçeğe dönüştürelim.
                    </p>

                </div>


                <a routerLink="/contact" class="btn-anameta contact-button">

                    <span>
                        İletişime Geçin
                    </span>

                    <svg viewBox="0 0 24 24">
                        <path d="M5 12H19"></path>
                        <path d="M14 7L19 12L14 17"></path>
                    </svg>

                </a>

            </div>

        </div>

    </section>

</div>